import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { GtmStatsDataEcommerceImpressionOnScrollInterface } from '../data/ecommerce-impression-on-scroll.interface';

export class GtmStatsAdapterEcommerceImpressionOnScroll implements StatsAdapterInterface {
  /**
   *
   * @param entity
   */
  constructor(protected entity: GtmStatsDataEntityInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEcommerceImpressionOnScrollInterface {
    return {
      ecommerce: {
        impressions: [this.entity],
      },
      event: 'impressionOnScroll',
    };
  }
}
